module.exports = __webpack_public_path__ + "static/media/option-1.135a83a1.ogg";